import { Document, visit } from "yaml";

import type { SlotLook } from "../../render/materials/slotLook";
import { PRESET_IDS } from "../viewerConstants";

export interface ModelLook {
  scale: number;
  rotationYDegrees: number;
  materials: Record<string, SlotLook>;
}

export function lookToYaml(fileName: string, look: ModelLook): string {
  const overriddenMaterials = Object.fromEntries(
    Object.entries(look.materials).flatMap(([slot, slotLook]) => {
      if (slotLook.mode === "original") return [];
      const { mode, ...params } = slotLook;
      return [[slot, { preset: PRESET_IDS[mode], params }]];
    })
  );

  const document = new Document({
    model: `models/${fileName}`,
    transform: { scale: round(look.scale), rotate: [0, round(look.rotationYDegrees), 0] },
    ...(Object.keys(overriddenMaterials).length > 0 && { materials: overriddenMaterials })
  });
  visit(document, {
    Seq(_, sequence) {
      sequence.flow = true;
    }
  });
  return document.toString();
}

function round(value: number): number {
  return Number(value.toFixed(3));
}
